import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getAllTenants = async () => {
  //   const authState = getAuthenticationState();
  try {
    const resp = await apiClient.get(`/tenant/allTenants`, {
      // headers: {
      //   authorization: `Bearer ${authState.token}`
      // }
    });

    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
